// export const API_ROOT_URL = 'https://zfarmacia.it/api/v1/backend';
// export const API_ROOT_URL = 'http://79.58.24.215:8087/v1/backend';
// export const API_ROOT_URL = 'https://api.farmakom.it/v1/backend'
// export const API_ROOT_URL = 'http://localhost:8082/v1/backend';
// export const API_ROOT_URL = 'http://192.168.1.101:8087/v1/backend'
// export const API_ROOT_URL = 'http://127.0.0.1:8082/v1/backend';
// export const API_ROOT_URL = 'https://api.farmakom.it/v1/backend'

import { API_ROOT_URL } from "../config";
import { getContractProduct } from "../reducers/modules/Contratto";
// import { components } from "react-select";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const getAuthHeaders = () => {
  return {
    ...headers,
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
};

const api = {
  getContractById: (id) => {
    return {
      endpoint: `${API_ROOT_URL}/contract/${id}`,
      method: "GET",
      headers: getAuthHeaders(),
      params: { id },
    };
  },
  getContractList: (token) => {
    return {
      endpoint: `${API_ROOT_URL}/contract`,
      method: "GET",
      headers: getAuthHeaders(),
    };
  },
  getContractProduct: () => {
    return {
      endpoint: `${API_ROOT_URL}/contract/contract-products`,
      method: "GET",
      headers: getAuthHeaders(),
    };
  },
  saveContract: (data) => {
    return {
      endpoint: `${API_ROOT_URL}/pdf/create`,
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    };
  },
  savePriceQuotation: (data) => {
    return {
      endpoint: `${API_ROOT_URL}/pdf/price-quotation`,
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    };
  },
  sendContract: (contractId) => {
    return {
      endpoint: `${API_ROOT_URL}/pdf/send/${contractId}`,
      method: "POST",
      headers: getAuthHeaders(),
    };
  },
  remindContract: (contractId) => {
    return {
      endpoint: `${API_ROOT_URL}/pdf/remind/${contractId}`,
      method: "POST",
      headers: getAuthHeaders(),
    };
  },
  loadContractBySaler: (salerId) => {
    return {
      endpoint: `${API_ROOT_URL}/pdf/load-contract-by-saler`,
      method: "POST",
      headers: headers,
    };
  },
  login: (dataLogin) => {
    return {
      endpoint: `${API_ROOT_URL}/agents/login`,
      method: "POST",
      headers: headers,
      data: JSON.stringify(dataLogin),
    };
  },
  getAgent: (token) => {
    return {
      endpoint: `${API_ROOT_URL}/agents/get`,
      method: "GET",
      headers: getAuthHeaders(),
    };
  },
  getCompanyData: (vat) => {
    return {
      endpoint: `${API_ROOT_URL}/atoka`,
      method: "GET",
      headers: getAuthHeaders(),
      params:{
        token:"25059d61-87b6-4285-a952-d88d4c8fd650-e",
        fields:"items",
        vat:vat,
        package:"*",
        countries:"it"
      }
    };
  },
};

export default api;
